// extracted by mini-css-extract-plugin
export var displayNone = "_s0-6";
export var imgContainer = "_s0-2";
export var overflowHidden = "_s0-3";
export var productInfoCardButtonContainer = "_s0-5";
export var productTitleText = "_s0-4";
export var rightArrow = "_s0-1";
export var rightArrowContainer = "_s0-0";